import { EditRegularIcon, TrashRegularIcon } from "@elixir/icons";
import { TWorkflowView } from "@elixir/types";
import { TableDataCell, TertiaryIconButton } from "ui";
import dateFormat from "dateformat";

export type TAlign = "left" | "right" | "center";

type THeaderConfigItem = {
  key: string;
  width?: string | number;
  title: string;
  align?: TAlign;
};

export type THeaderConfig = Array<THeaderConfigItem>;

type TViewAllQueuesTableRowItemUiProps = {
  rowConfig: Record<string, Pick<THeaderConfigItem, "width" | "align">>;
  viewItem: TWorkflowView & { patient_count: number };
  isLastItem: boolean;
  onEditClick: () => void;
  onDeleteClick: () => void;
};

const ViewAllQueuesTableRowItemUi = ({
  isLastItem,
  rowConfig,
  viewItem,
  onEditClick,
  onDeleteClick,
}: TViewAllQueuesTableRowItemUiProps) => {
  return (
    <div
      className={`dr-flex dr-items-center dr-w-full ${!isLastItem ? "dr-border-b-1 dr-border-darwin-neutral-200 " : "dr-rounded-b-8"}`}
    >
      <TableDataCell
        width={rowConfig.queue_name.width}
        align={rowConfig.queue_name.align}
      >
        {viewItem.name}
      </TableDataCell>
      <TableDataCell
        width={rowConfig.patients_in_queue.width}
        align={rowConfig.patients_in_queue.align}
      >
        {viewItem.patient_count}
      </TableDataCell>
      <TableDataCell
        width={rowConfig.created_at.width}
        align={rowConfig.created_at.align}
      >
        {viewItem.createdAt
          ? dateFormat(new Date(viewItem.createdAt!), "dd/mm/yyyy, h:MM TT")
          : "System Default"}
      </TableDataCell>
      {/* <TableDataCell
        width={rowConfig.archive.width}
        align={rowConfig.archive.align}
      >
        <SwitchButton
          onChange={onSwitchClick}
          checked={!serviceItem.archive}
          activeColorHex="#19A66A"
          inActiveColorHex="#BABABA"
        />
      </TableDataCell> */}
      <TableDataCell width={rowConfig.edit.width} align={rowConfig.edit.align}>
        <div className="dr-w-full dr-flex dr-justify-end">
          <TertiaryIconButton
            IconComponent={() => (
              <EditRegularIcon className="dr-text-darwin-touch-primary-primary" />
            )}
            onClick={onEditClick}
          />
          <TertiaryIconButton
            IconComponent={() => (
              <TrashRegularIcon className="dr-text-darwin-touch-red-primary" />
            )}
            onClick={onDeleteClick}
          />
        </div>
      </TableDataCell>
    </div>
  );
};

export default ViewAllQueuesTableRowItemUi;
